import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { UserUtil } from 'src/app/data/utils/user.utils';

@Component({
  selector: 'app-chat-initial',
  templateUrl: './chat-initial.component.html',
  styleUrls: ['./chat-initial.component.scss'],
})
export class ChatInitialComponent implements OnInit, OnChanges {
  @Input() existMessage: boolean = false;
  @Input() loadingList: boolean = false;
  text: string = '';
  loading: boolean = false;
  constructor(private readonly userUtil: UserUtil) {}

  get userName() {
    return this.userUtil.getUser().firstName;
  }

  ngOnInit() {
    this.userName;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.selectText(changes);
      this.loadingProcess(changes);
    }
  }

  loadingProcess(changes: any) {
    if (changes.loadingList.currentValue) {
      this.loading = true;
    } else {
      this.loading = false;
    }
  }

  selectText(changes: any) {
    if (changes.existMessage) {
      this.text = 'Selecione uma conversa ou inicie uma nova';
    } else {
      this.text = 'Nenhuma conversa encontrada, vamos iniciar uma nova?';
    }
  }
}
